// src/pages/TikTokShop.jsx
// Dedicated TikTok Shop revenue page. Sits in the E-commerce nav group
// alongside Shopify Stores — TikTok Shop is e-commerce, not ad-revenue,
// so it doesn't belong in the Publisher dashboard.
//
// All of the actual UI lives in the reusable TikTokShopSection component;
// this page is just a thin wrapper with a page header.

import TikTokShopSection from '../components/TikTokShopSection';

export default function TikTokShop() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold flex items-center gap-2">
          <span>🛍️</span> TikTok Shop
        </h1>
        <p className="text-muted-foreground text-sm">
          Track TikTok Shop GMV, orders, refunds and net revenue.
          Combined with Shopify on the E-commerce dashboard.
        </p>
      </div>

      <TikTokShopSection />
    </div>
  );
}
